export const sygnet = ['640 640', `
  <title>titanium logo</title>
  <defs>
    <path d="M507.41 54.15L507.41 16.43L628.66 110.74L503.37 205.04L504.71 161.93L353.82 160.59L355.17 620L213.71 620L213.71 157.89L62.81 157.89L62.81 54.15L507.41 54.15Z" id="d2yp62UmLE"/>
  </defs>
  <g>
    <g>
      <g>
        <g>
          <filter id="shadow13548028" x="53.81" y="7.43" width="584.85" height="622.57" filterUnits="userSpaceOnUse" primitiveUnits="userSpaceOnUse">
            <feFlood/>
            <feComposite in2="SourceAlpha" operator="in"/>
            <feGaussianBlur stdDeviation="1"/>
            <feOffset dx="1" dy="1" result="afterOffset"/>
            <feFlood flood-color="#000000" flood-opacity="0.51"/>
            <feComposite in2="afterOffset" operator="in"/>
            <feMorphology operator="dilate" radius="1"/>
            <feComposite in2="SourceAlpha" operator="out"/>
          </filter>
          <path d="M507.41 54.15L507.41 16.43L628.66 110.74L503.37 205.04L504.71 161.93L353.82 160.59L355.17 620L213.71 620L213.71 157.89L62.81 157.89L62.81 54.15L507.41 54.15Z" id="e4jjdfCmr3" fill="white" fill-opacity="1" filter="url(#shadow13548028)"/>
        </g>
        <use xlink:href="#d2yp62UmLE" opacity="1" fill="#ffffff" fill-opacity="1"/>
        <g>
          <use xlink:href="#d2yp62UmLE" opacity="1" fill-opacity="0" stroke="#000000" stroke-width="1" stroke-opacity="1"/>
        </g>
        <g>
          <filter id="shadow2091663" x="53.81" y="7.43" width="584.85" height="622.57" filterUnits="userSpaceOnUse" primitiveUnits="userSpaceOnUse">
            <feFlood/>
            <feComposite in2="SourceAlpha" operator="out"/>
            <feGaussianBlur stdDeviation="1"/>
            <feOffset dx="1" dy="1" result="afterOffset"/>
            <feFlood flood-color="#ffffff" flood-opacity="0.8"/>
            <feComposite in2="afterOffset" operator="in"/>
            <feMorphology operator="dilate" radius="1"/>
            <feComposite in2="SourceAlpha" operator="in"/>
          </filter>
          <path d="M507.41 54.15L507.41 16.43L628.66 110.74L503.37 205.04L504.71 161.93L353.82 160.59L355.17 620L213.71 620L213.71 157.89L62.81 157.89L62.81 54.15L507.41 54.15Z" id="d1anoXvp5Q" fill="white" fill-opacity="1" filter="url(#shadow2091663)"/>
        </g>
      </g>
    </g>
  </g>
`]
